import React, { useEffect } from "react";
import { Card, Row, Col, Button } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { setFilters } from "../expenseRecognitionSlice";
import {
  fetchEmployees,
  fetchUsers,
} from "../../../store/commonThunks/lookups";
import SearchListAutoComplete from "../../../components/SearchListAutoComplete";
import { SearchOutlined } from "@ant-design/icons";
import RecordDateFilter from "../../../components/filters/RecordDateFilter";
import { useDefaultDateRange } from "../../../hooks/useDefaultDateRange";
import { fetchExpenseRecognition } from "../expenseRecognitionThunk";
import CommonDateRangeFilter from "../../../components/common/filters/CommonDateRangeFilter";

const ExpenseRecognitionFilters = () => {
  const dispatch = useDispatch();
  const { filters } = useSelector((state) => state.expenseRecognition);
  const lookups = useSelector((state) => state.lookups);

  useDefaultDateRange(setFilters, filters, "today"); // default today
  const dynamicSpan = 3;

  useEffect(() => {
    dispatch(fetchEmployees());
    dispatch(fetchUsers());
  }, [dispatch]);

  const handleFilterChange = (field, value) => {
    dispatch(setFilters({ [field]: value }));
    dispatch({ type: "expenseRecognition/resetList" });
  };

  const handleSubmit = () => {
    dispatch(fetchExpenseRecognition({ filters }));
  };

  return (
    <Card className="mb-4 shadow-md rounded-xl">
      <Row gutter={16} style={{ alignItems: "center" }}>
        {/* Filter Type */}
        <Col flex="1 1 220px" style={{ minWidth: 200 }}>
          <label>Filter Type</label>
          <SearchListAutoComplete
            optionsList={[
              { sale_id: "All", display_text: "All" },
              { sale_id: "By User", display_text: "By User" },
            ]}
            value={{ value: filters.filterType, label: filters.filterType }}
            onSelect={(obj) => handleFilterChange("filterType", obj?.sale_id)}
            placeholder="Filter Type"
            showAddNew={false}
          />
        </Col>

        {filters.filterType === "By User" && (
          <Col flex="1 1 220px" style={{ minWidth: 200 }}>
            <label>Search User</label>
            <SearchListAutoComplete
              entityType="user"
              optionsList={lookups.users.map((e) => ({
                sale_id: e.id,
                display_text: e.full_name,
              }))}
              onSelect={(obj) => handleFilterChange("userId", obj?.sale_id)}
              placeholder="User"
              showAddNew={false}
            />
          </Col>
        )}

        {/* Record Type */}
        <Col flex="1 1 220px" style={{ minWidth: 200 }}>
          <label>Record Type</label>
          <SearchListAutoComplete
            optionsList={[
              { sale_id: "without details", display_text: "Without Details" },
              { sale_id: "with details", display_text: "With Details" },
            ]}
            value={{ value: filters.recordType, label: filters.recordType }}
            onSelect={(obj) => handleFilterChange("recordType", obj?.sale_id)}
            placeholder="Record Type"
            showAddNew={false}
          />
        </Col>

        {/* Date Range */}
        <CommonDateRangeFilter
          filters={filters}
          onChange={(fromDate, toDate) => {
          handleFilterChange("fromDate", fromDate);
          handleFilterChange("toDate", toDate);
          }}
        />

        {/* Report Button */}
        <Col
          span={dynamicSpan}
          style={{ display: "flex", alignItems: "flex-end", height: 58 }}
        >
          <Button
            type="primary"
            icon={<SearchOutlined />}
            onClick={handleSubmit}
            block
            data-testid="report-btn"
          >
            Report
          </Button>
        </Col>
      </Row>
    </Card>
  );
};

export default ExpenseRecognitionFilters;
